import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import ArtistDetail from './ArtistDetail';
import VenueDetail from './VenueDetail';
import EventDetail from './EventDetail';

// These are real app routes — don't treat them as SHARC IDs
const RESERVED_PATHS = new Set([
    'artists', 'venues', 'events', 'add-artist', 'add-venue', 'add-event', 'picklists'
]);

function SharcIdPage() {
    const { sharcId } = useParams();
    const navigate = useNavigate();
    const [resolved, setResolved] = useState(null);
    const [loading, setLoading] = useState(true);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        // Don't attempt to resolve known app routes
        if (RESERVED_PATHS.has(sharcId)) {
            navigate('/', { replace: true });
            return;
        }

        setLoading(true);
        setNotFound(false);
        setResolved(null);

        axios.get(`${config.API_URL}/sharc/${sharcId}`)
            .then(res => {
                setResolved(res.data);
                setLoading(false);
            })
            .catch(err => {
                if (err.response && err.response.status === 404) {
                    setNotFound(true);
                }
                setLoading(false);
            });
    }, [sharcId, navigate]);

    if (loading) {
        return <div style={styles.message}>Loading...</div>;
    }

    if (notFound) {
        return (
            <div style={styles.notFound}>
                <div style={styles.notFoundCode}>404</div>
                <div style={styles.notFoundTitle}>SHARC ID not found</div>
                <div style={styles.notFoundText}>
                    <span style={{ color: '#bb86fc' }}>/{sharcId}</span> doesn't exist yet.
                </div>
            </div>
        );
    }

    if (!resolved) return null;

    if (resolved.type === 'artist') return <ArtistDetail slugOverride={resolved.slug} />;
    if (resolved.type === 'venue') return <VenueDetail slugOverride={resolved.slug} />;
    if (resolved.type === 'event') return <EventDetail slugOverride={resolved.slug} />;

    return null;
}

const styles = {
    message: { textAlign: 'center', color: '#aaa', fontSize: '16px', padding: '60px 0' },
    notFound: { textAlign: 'center', padding: '80px 0' },
    notFoundCode: { fontSize: '72px', fontWeight: 'bold', color: '#333', marginBottom: '16px' },
    notFoundTitle: { fontSize: '24px', color: '#e0e0e0', marginBottom: '12px' },
    notFoundText: { fontSize: '16px', color: '#aaa' },
};

export default SharcIdPage;